import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";

import type { HotelSearchFormValues } from "@/features/hotels/utils/hotelsValidation";

export interface HotelSearchDataContextValue {
  searchData: HotelSearchFormValues | null;
  updateSearchData: Dispatch<SetStateAction<HotelSearchFormValues | null>>;
}

export const HotelSearchDataContext =
  createContext<HotelSearchDataContextValue | null>(null);

export const useHotelSearchDataContext = () => {
  const context = useContext(HotelSearchDataContext);
  if (!context) {
    throw new Error(
      "useHotelSearchDataContext must be used within a HotelSearchDataProvider",
    );
  }
  return context;
};
